import { Module, VuexModule, Action } from "vuex-module-decorators";
import api from "@/api/invest";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async add_stadium(params: any) {
    return api.add_stadium(params);
  }
  @Action
  async save_stadium(params: any) {
    return api.save_stadium(params);
  }
  @Action
  async stadium_info(params: any) {
    return api.stadium_info(params);
  }
  @Action
  async list_stadium(params: any) {
    return api.list_stadium(params);
  }
  @Action
  async my_stadium(params: any) {
    return api.my_stadium(params);
  }
  @Action
  async config_agreement(params: any) {
    return api.config_agreement(params);
  }
  @Action
  async release_agreement(params: any) {
    return api.release_agreement(params);
  }
  @Action
  async config_manager(params: any) {
    return api.config_manager(params);
  }
  @Action
  async config_stadium(params: any) {
    return api.config_stadium(params);
  }
  @Action
  async set_invalid(params: any) {
    return api.set_invalid(params);
  }
  @Action
  async invalid_info(params: any) {
    return api.invalid_info(params);
  }
  @Action
  async prepare_share(params: any) {
    return api.prepare_share(params);
  }
  @Action
  async submit(params: any) {
    return api.submit(params);
  }
}
